import { css, keyframes } from '@emotion/react'
import styled from '@emotion/styled'

const spin = keyframes`
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
`

const SIZE_MAP = {
  xsmall: 8,
  small: 16,
  medium: 24,
  large: 48,
  xlarge: 96,
} as const

export const SpinnerWrapper = styled.div<{ size: keyof typeof SIZE_MAP }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;

  ${({ size }) => css`
    width: ${SIZE_MAP[size]}px;
    height: ${SIZE_MAP[size]}px;
  `}

  svg {
    width: 100%;
    height: 100%;
    animation: ${spin} 1s linear infinite;
  }
`
